import React from "react";
import { useDispatch } from "react-redux";

import MaterialTable from "material-table";

import {
  updateCompanyAddress,
  getCompanyAddresses,
} from "../../helpers/services/CompanyServices";
import CompanyActionTypes from "../../redux/company/company.types";

export default ({ companyId, addresses, onNewAddressAdded }) => {
  const dispatch = useDispatch();

  var addressColumns = [
    { title: "id", field: "id", hidden: true },
    {
      title: "Typ",
      field: "address_type",
      lookup: { Legal: "Legal" },
    },
    {
      title: "Straße",
      field: "street",
      validate: (rowData) => (rowData.street === "" ? "erforderlich" : ""),
    },
    {
      title: "Hausnummer",
      field: "house_no",
      validate: (rowData) => (rowData.house_no === "" ? "erforderlich" : ""),
    },
    {
      title: "PLZ",
      field: "zip_code",
      validate: (rowData) => (rowData.zip_code === "" ? "erforderlich" : ""),
    },
    {
      title: "Ort",
      field: "city",
      validate: (rowData) => (rowData.city === "" ? "erforderlich" : ""),
    },
    {
      title: "Land",
      field: "country",
      lookup: { Deutschland: "Deutschland" },
      validate: (rowData) => (rowData.street === "" ? "erforderlich" : ""),
    },
  ];

  const refreshData = async () => {
    console.log(companyId);
    const response = await getCompanyAddresses(companyId);
    dispatch({
      type: CompanyActionTypes.RETRIEVE_COMPANY_DETAILS,
      payload: { addresses: response },
    });
    return;
  };
  const handleRowUpdate = async (newData, oldData, resolve, reject) => {
    console.log(newData);
    await updateCompanyAddress({
      company_id: companyId,
      country_code: "DEU",
      ...newData,
    });
    await refreshData();
    onNewAddressAdded();
    resolve();
  };
  const handleRowAdd = async (newData, resolve, reject) => {
    console.log(newData);
    if (
      !newData.city ||
      !newData.street ||
      !newData.address_type ||
      !newData.zip_code
    )
      reject();
    else {
      await updateCompanyAddress({
        company_id: companyId,
        country_code: "DEU",
        ...newData,
      });
      await refreshData();
      resolve();
    }
  };

  return (
    <MaterialTable
      title=""
      columns={addressColumns}
      data={addresses || []}
      options={{
        actionsColumnIndex: -1,
      }}
      localization={{
        body: {
          emptyDataSourceMessage: "Keine Einträge",
          addTooltip: "Hinzufügen",
          deleteTooltip: "Löschen",
          editTooltip: "Bearbeiten",
          filterRow: {
            filterTooltip: "Filter",
          },
          editRow: {
            deleteText: "Diese Zeile wirklich löschen?",
            cancelTooltip: "Abbrechen",
            saveTooltip: "Speichern",
          },
        },
        grouping: {
          placeholder: "Spalten ziehen ...",
          groupedBy: "Gruppiert nach:",
        },
        header: {
          actions: "Aktionen",
        },
        pagination: {
          labelDisplayedRows: "{from}-{to} von {count}",
          labelRowsSelect: "Zeilen",
          labelRowsPerPage: "Zeilen pro Seite:",
          firstAriaLabel: "Erste Seite",
          firstTooltip: "Erste Seite",
          previousAriaLabel: "Vorherige Seite",
          previousTooltip: "Vorherige Seite",
          nextAriaLabel: "Nächste Seite",
          nextTooltip: "Nächste Seite",
          lastAriaLabel: "Letzte Seite",
          lastTooltip: "Letzte Seite",
        },
        toolbar: {
          addRemoveColumns: "Spalten hinzufügen oder löschen",
          nRowsSelected: "{0} Zeile(n) ausgewählt",
          showColumnsTitle: "Zeige Spalten",
          showColumnsAriaLabel: "Zeige Spalten",
          exportTitle: "Export",
          exportAriaLabel: "Export",
          exportName: "Export als CSV",
          searchTooltip: "Suche",
          searchPlaceholder: "Suche",
        },
      }}
      editable={{
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve, reject) => {
            handleRowUpdate(newData, oldData, resolve, reject);
          }),
        onRowAdd: (newData) =>
          new Promise((resolve, reject) => {
            handleRowAdd(newData, resolve, reject);
          }),
      }}
    />
  );
};
